import { isRouteErrorResponse, useRouteError } from 'react-router'

/**
 *  @group UI Components
 */
export const NotFound = () => {
  const error = useRouteError()
  console.log(error, isRouteErrorResponse(error), 'here')

  return (
    <div className="flex size-full grow items-center justify-center">
      <h2>Page Not Found</h2>
    </div>
  )
}
